<template lang="pug">
.card.height-100
  .card-body
    .columns
      .column.col-2(v-if="productItem.cover")
        img.img-responsive(v-if="productItem.cover" :src="productItem.cover")
        .empty(v-else)
          .fas.fa-camera
      .column
        .text Título: #[b {{ productItem.title }}]
        .text.mt-1 Idioma: #[b {{ productItem.language | language }}]
        .text.mt-1 Nº capítulo: #[b {{ productItem.chapterNumber }}]
        .text.mt-1 Publicação: #[b {{ productItem.publishDate | toDate }}]
        .text.mt-1 Autores: #[b(v-for="author, index in productItem.authors") {{ author.name }}#[span(v-if="productItem.authors.length > index+1") , ]]
        .mt-1(v-if="productItem.doiLink")
          a.text-error(:href="productItem.doiLink" target="_blank") Abrir link DOI
    .mt-2(v-if="productItem.data")
      .divider.text-center(data-content="Itens customizados")
      div(v-for="(value, key) in productItem.data")
        small {{ key }}: #[b {{ value }}]
  .card-footer
    .buttons-container(v-if="!disabled")
        a.btn.btn-action.btn-sm.text-error.btn-link.tooltip(
          data-tooltip="Excluir"
          @click="$emit('remove', productItem)"
        )
          i.fas.fa-trash-alt
        a.btn.btn-action.btn-sm.btn-link.tooltip(
          data-tooltip="Editar" 
          @click="$emit('update', productItem)"
        )
          i.fas.fa-edit
</template>

<script>
export default {
  props: {
    productItem: { type: Object, required: true },
    disabled: { type: Boolean, required: true },
  },
}
</script>

<style lang="stylus" scoped>
.empty
  padding 1rem 0

.card-footer
  padding-top 0
  padding-bottom 0

  .buttons-container
    text-align right
</style>
